import { $, $$, BREAKPOINTS } from '../_utils'

class LinksList {
  constructor($list) {
    this.$list = $list
    this.$content = $('.list-items-group', this.$list)
    this.$titleLink = $('.list-wrapper__title', this.$list)
  }

  addListToggleListener = () => {
    if (this.isToggleDisabledAtCurrentWidth()) return
    const $innerButton = $('button', this.$titleLink)
    const $trigger = $innerButton || this.$titleLink
    $trigger.addEventListener('click', this.handleListToggle)
  }

  getViewportWidth = () => window.innerWidth

  handleListToggle = () => {
    if (this.$content.classList.contains('open')) {
      this.$content.classList.remove('open')
      this.$titleLink.classList.remove('open')
      this.$content.style.height = 0
    } else {
      this.$content.classList.add('open')
      this.$titleLink.classList.add('open')
      this.$content.style.height = `${this.$content.scrollHeight}px`
    }
  }

  isToggleDisabledAtCurrentWidth = () => {
    const breakpoint = this.$titleLink.dataset.breakpoint
    this.getViewportWidth() >= BREAKPOINTS[breakpoint]
    return breakpoint ? this.getViewportWidth() >= BREAKPOINTS[breakpoint] : false
  }

  init = () => {
    if (!this.$titleLink || !this.$content) return

    this.addListToggleListener()
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const $$lists = $$('.list-wrapper')

  $$lists.forEach($list => {
    const linksList = new LinksList($list)
    linksList.init()
  })
})
